// extracted by mini-css-extract-plugin
export default {"root":"search_input_root__2w9Yz","search_icon":"search_input_search_icon__Fbv7f"};